import React from 'react';
import Container from '../../components/container/container.component';
import MainHeading from '../../components/main-heading/main-heading.component';
import ContactPageContainer from './contact.styles';

const ContactPage = () => {
    return (
        <ContactPageContainer id="Contact">
            <Container>
                <div className="container">
                    <MainHeading title="Contact Us" />
                    <div className="content">
                        <form action="">
                            <input
                                className="main-input"
                                type="text"
                                name="name"
                                placeholder="Your Name"
                            />
                            <input
                                className="main-input"
                                type="email"
                                name="mail"
                                placeholder="Your Email"
                            />
                            <textarea
                                className="main-input"
                                name="message"
                                placeholder="Your Message"
                            ></textarea>
                            <input type="submit" value="Send Message" />
                        </form>
                        <div className="info">
                            <h4>Get In Touch</h4>
                            <span className="phone">+963 937.993.905</span>
                            <span className="phone">+963 940.207.384</span>
                            <h4>Where We Are</h4>
                            <address>
                                Syria Damascus
                                <br />
                                123-4567-890
                                <br />
                                Syria
                            </address>
                        </div>
                    </div>
                </div>
            </Container>
        </ContactPageContainer>
    );
};
export default ContactPage;
